export class Invoice {
    public InvoiceId: string;
    public PaymentAmount: string;
    constructor() { }
} 